import * as Yup from "yup"

export const workOrderValidationSchema = (t) =>
  Yup.object().shape({
    vehicleId: Yup.string().required(t("global.vehicle_is_required", "Vehicle is required")),
    message: Yup.string().max(
      350,
      t("global.description_can_only_350", "Message must be a maximum of 350 characters")
    ),
    emailRecipient: Yup.string().email(t("global.must_be_a_valid_email", "Must be a valid email")).max(255)
  })
